module.exports = __webpack_public_path__ + "icon-cross.png?0a3a3ca99023f12c819233fb1e5e8dd2";


//////////////////
// WEBPACK FOOTER
// ./images/icon-cross.png
// module id = 170
// module chunks = 0